// permission.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/internal/operators/filter';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private employeePermissions$ = new BehaviorSubject<any>(null);
  private employeeData$ = new BehaviorSubject<any>(null);

  constructor() {}

  setPermissions(employeePerms: any) {
    localStorage.setItem('emppermissions', JSON.stringify(employeePerms));
    this.employeePermissions$.next(employeePerms);
  }

  getEmployeePermissions() {
    return this.employeePermissions$.asObservable();
  }

  getEmployeePermissionsValue() {
    return this.employeePermissions$.getValue();
  }

  //this for permission gaurd  only dont use else where 
  //in gaurd need to wait
   
  getPermissionsAsync(): Promise<any> {
  const current = this.employeePermissions$.getValue();
  if (current) return Promise.resolve(current);
  return this.employeePermissions$.pipe(filter(p => !!p), take(1)).toPromise();
}

  setEmployeeData(data: any) {
    localStorage.setItem('empdata', JSON.stringify(data));
    this.employeeData$.next(data);
  }

  getEmployeeData() {
    return this.employeeData$.asObservable();
  }

  getEmployeeDataAsync(): Promise<any> {
    const current = this.employeeData$.getValue();
    if (current) return Promise.resolve(current);

    const storedData = localStorage.getItem('empdata');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        this.employeeData$.next(parsedData);
        return Promise.resolve(parsedData);
      } catch (error) {
        localStorage.removeItem('empdata');
      }
    }

    return this.employeeData$.pipe(filter(p => !!p), take(1)).toPromise();
  }

  getEmployeeDataValue() {
    return this.employeeData$.getValue();
  }

}
